import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselPrevious,
    CarouselNext,
} from "@/components/ui/carousel";
import { ArrowRight, ChevronLeft, ChevronRight} from "lucide-react";
import {SafeLink} from "../../../../ui/SafeLink";


const subCategories = [
    {
        title: "Kitchens",
        to: "/kitchens/",
        image: `${process.env.REACT_APP_BLOB_URL}/www/img/kitchens/kitchen-projects.png`,
        alt: "A brightly lit modern kitchen with light coloured cabinets and matching island benchtop. On top of the benchtop is an undermount kitchen sink with a brass gooseneck tap. Behind the kitchen island is a gas hob.",
    },
    {
        title: "Complete Interior Packages",
        to: "/turn-key/",
        image: `${process.env.REACT_APP_BLOB_URL}/www/img/kitchens/complete-fitout-dining-kitchen.png`,
        alt: "Modern kitchen and dining space featuring custom cabinetry, stone benchtops, integrated sink with gunmetal gooseneck tap, and contemporary dining furniture.",
    },
    {
        title: "Furniture",
        to: "/furniture-and-bedding/",
        image: `${process.env.REACT_APP_BLOB_URL}/www/img/kitchens/modern-apartment.png`,
        alt: "Premium living room featuring high-quality furniture and décor including a leather armchair, upholstered sofa, designer lighting and contemporary coffee table.",
    },
    {
        title: "Bedding & Decor",
        to: "/furniture-and-bedding/",
        image: `${process.env.REACT_APP_BLOB_URL}/www/img/kitchens/bedding-and-beds.png`,
        alt: "Upholstered bed with layered bedding, decorative cushions and a bedroom bench in a contemporary bedroom setting.",
    },
    {
        title: "Enhance Guests’ in-stay experience",
        to: "/secure-guest-casting/",
        image: `${process.env.REACT_APP_BLOB_URL}/www/img/kitchens/in-room-secure-tv-casting.png`,
        alt: "Hotel room television displaying secure in-room TV casting platform above a media console in a modern guest accommodation setting.",
    },
    {
        title: "Heating & Cooling",
        to: "/heating-cooling/",
        image: `${process.env.REACT_APP_BLOB_URL}/www/img/kitchens/heating-modern-livingroom.png`,
        alt: "Modern living room featuring a built-in electric fireplace, contemporary seating and custom shelving in a residential-style interior.",
    },

];

interface OtherProjectCarouselProps {
    variant?: "dark" | "light" | "default";
}

export default function OtherProjectCarousel({
    variant = "default",
}: OtherProjectCarouselProps) {
    const isDark = variant === "dark";

    return (
        <div className={`w-full py-12 px-4 md:px-8 lg:px-16 ${variant === "dark" ? "bg-black" : variant === "default" ? "bg-gradient-to-b from-gray-50 to-gray-100" : "bg-white"}`}>
            {/* Heading */}
            {/* <div className="mb-8 max-w-7xl mx-auto">
                <h2 className={`text-3xl md:text-4xl lg:text-5xl font-bold mb-2 leading-tight ${isDark ? "text-white" : "text-gray-900"}`}>
                    <span className="hero-text-gradient-red">Bathroom</span> Sub-Categories
                </h2>
                <p className={`text-base md:text-lg leading-relaxed ${isDark ? "text-gray-400" : "text-gray-500"}`}>
                    Explore our full range of bathroom products and solutions.
                </p>
            </div> */}

            <div className="mb-8 max-w-7xl mx-auto text-center">
                <h2
                    className={`text-2xl sm:text-3xl md:text-4xl font-bold mb-2 leading-tight ${isDark ? "text-white" : "text-gray-900"
                        }`}
                >
                    <span className="hero-text-gradient-red">Procuring for other projects?</span> We can help.
                    {/* Procuring for other projects? We can help. */}
                </h2>
            </div>

            {/* Carousel */}
            <div className="relative w-full max-w-[1536px] mx-auto px-12">
                <Carousel
                    opts={{ loop: true, align: "center" }}
                    className="w-full"
                >
                    <CarouselContent>
                        {subCategories.map((item, index) => (
                            <CarouselItem
                                key={index}
                                className="basis-auto"
                            >
                                
                                    <SafeLink to={item.to} className="block group cursor-pointer">
                                        {/* Square Image */}
                                        <div className="w-[272px] h-[272px] mx-auto rounded-lg overflow-hidden mb-3">
                                            <img
                                                src={item.image}
                                                alt={item.alt}
                                                loading="lazy"
                                                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                                                onError={(e) => {
                                                    const target = e.target as HTMLImageElement;
                                                    target.onerror = null;
                                                    target.style.display = "none";
                                                }}
                                            />
                                        </div>

                                        {/* Name + Arrow below image */}
                                        <div className="flex items-center justify-between w-[272px] mx-auto px-4 sm:px-2 md:px-4 lg:px-1 xl:px-1">
                                            <span className={`text-sm font-medium transition-colors duration-200 group-hover:text-harvey-red ${isDark ? "text-white" : "text-gray-800"}`}>
                                                {item.title}
                                            </span>
                                            <ArrowRight className={`w-4 h-4 transition-all duration-200 group-hover:translate-x-1 group-hover:text-harvey-red ${isDark ? "text-gray-400" : "text-gray-500"}`} />
                                        </div>
                                    </SafeLink>
                                
                            </CarouselItem>
                        ))}
                    </CarouselContent>
                    <CarouselPrevious icon={ChevronLeft} variant="ghost" size="custom" className={`absolute -left-14 top-[136px] z-10 !size-12 [&_svg]:size-6 ${isDark ? "bg-white/10 hover:bg-white/20 border border-white/30 text-white hover:!text-harvey-red" : "bg-gray-100 hover:bg-gray-200 border border-gray-300 text-gray-600 hover:!text-harvey-red"}`} />
                    <CarouselNext icon={ChevronRight} variant="ghost" size="custom" className={`absolute -right-14 top-[136px] z-10 !size-12 [&_svg]:size-6 ${isDark ? "bg-white/10 hover:bg-white/20 border border-white/30 text-white hover:!text-harvey-red" : "bg-gray-100 hover:bg-gray-200 border border-gray-300 text-gray-600 hover:!text-harvey-red"}`} />
                </Carousel>
            </div>
        </div>
    );
}
